module.exports = __webpack_public_path__ + "img/what.4570beb0.jpg";